import { observable } from "mobx"
import Constants from "../../common/constants/Constants"
import { getRequest } from "../../common/helpers/RequestHelper"
import { appStore } from "../../common/store/AppStore";
import HttpStatusCode from './../../common/constants/HttpErrorCode';
import { IShortCompanyInfo, IStockSymbol, STOCK_BG_COLOR_CONIG } from './../../common/model/Model';
import _ from 'lodash'
interface ISuggestion {
    id: number;
    ticker: string;
    buyDate: Date;
    buyPrice: number;
    currentPrice: number;
    profit: number;
    volume: number;
    sessionNumber: number;
    sellDate: Date;
    sellPrice: number;
    basicPrice: number
    ceilingPrice: number
    floorPrice: number
    matchPrice: number
    colorUpdate: string
}
interface ISuggestionInfo {
    page: number,
    size: number,
    data?: ISuggestion[],
    keySearch: string,
    showAutoCompleteForm: boolean,
    listShortCompany: IShortCompanyInfo[],
    totalPages: number
}
export enum SuggestionType {
    BUY = "BUY",
    SELL = "SELL",
    HOLD = "HOLD",
    COMBINATION = "COMBINATION"
}
class StockRecommendationStore {
    @observable buyInfo: ISuggestionInfo = {
        page: 1,
        size: 10,
        data: undefined,
        keySearch: "",
        showAutoCompleteForm: false,
        listShortCompany: [],
        totalPages: 0
    }
    @observable sellInfo: ISuggestionInfo = {
        page: 1,
        size: 10,
        data: undefined,
        keySearch: "",
        showAutoCompleteForm: false,
        listShortCompany: [],
        totalPages: 0
    }
    @observable holdInfo: ISuggestionInfo = {
        page: 1,
        size: 10,
        data: undefined,
        keySearch: "",
        showAutoCompleteForm: false,
        listShortCompany: [],
        totalPages: 0
    }
    @observable combinationInfo: ISuggestionInfo = {
        page: 1,
        size: 10,
        data: undefined,
        keySearch: "",
        showAutoCompleteForm: false,
        listShortCompany: [],
        totalPages: 0
    }
    @observable stockHolds: string[] = []
    @observable stockBuys: string[] = []

    async getBuys() {
        this.stockBuys = []
        const api = `GetListStockSuggestions?search=${this.buyInfo?.keySearch}&type=${SuggestionType.BUY}&pageSize=${this.buyInfo?.size}&pageIndex=${this.buyInfo?.page}`
        const result = await getRequest(Constants.API_DASHBOARD_URL + api)
        if (result.status < HttpStatusCode.CODE_300) {
            this.buyInfo.data = result.body.data
            this.buyInfo.totalPages = result.body.paging.totalPages
            this.buyInfo.data?.map((item) => {
                this.stockBuys.push(item.ticker)
                appStore.regisShortStockInfo()
            })
        }
    }
    async getSells() {
        const api = `GetListStockSuggestions?search=${this.sellInfo?.keySearch}&type=${SuggestionType.SELL}&pageSize=${this.sellInfo?.size}&pageIndex=${this.sellInfo?.page}`
        const result = await getRequest(Constants.API_DASHBOARD_URL + api)
        if (result.status < HttpStatusCode.CODE_300) {
            this.sellInfo.data = result.body.data
            this.sellInfo.totalPages = result.body.paging.totalPages
        }
    }
    async getHolds() {
        this.stockHolds = []
        const api = `GetListStockSuggestions?search=${this.holdInfo?.keySearch}&type=${SuggestionType.HOLD}&pageSize=${this.holdInfo?.size}&pageIndex=${this.holdInfo?.page}`
        const result = await getRequest(Constants.API_DASHBOARD_URL + api)
        if (result.status < HttpStatusCode.CODE_300) {
            this.holdInfo.data = result.body.data
            this.holdInfo.totalPages = result.body.paging.totalPages
            this.holdInfo.data?.map((item) => {
                this.stockHolds.push(item.ticker)
                appStore.regisShortStockInfo()
            })
        }
    }
    async getCombinations() {
        const api = `GetListTradingHistory?search=${this.combinationInfo?.keySearch}&pageSize=${this.combinationInfo?.size}&pageIndex=${this.combinationInfo?.page}`
        const result = await getRequest(Constants.API_DASHBOARD_URL + api)
        if (result.status < HttpStatusCode.CODE_300) {
            this.combinationInfo.data = result.body.data
            this.combinationInfo.totalPages = result.body.paging.totalPages
        }
    }
    changePagePrev(type: string) {
        if (type === SuggestionType.BUY) {
            if (this.buyInfo.page > 1) {
                this.buyInfo.page -= 1;
                this.buyInfo.data = undefined
                this.getBuys()
            }
        }
        if (type === SuggestionType.SELL) {
            if (this.sellInfo.page > 1) {
                this.sellInfo.page -= 1;
                this.sellInfo.data = undefined
                this.getSells()
            }
        }
        if (type === SuggestionType.HOLD) {
            if (this.holdInfo.page > 1) {
                this.holdInfo.page -= 1;
                this.holdInfo.data = undefined
                this.getHolds()
            }
        }
        if (type === SuggestionType.COMBINATION) {
            if (this.combinationInfo.page > 1) {
                this.combinationInfo.page -= 1;
                this.combinationInfo.data = undefined
                this.getCombinations()
            }
        }
    }
    changePageNext(type: string) {
        if (type === SuggestionType.BUY) {
            if (this.buyInfo.page < this.buyInfo.totalPages) {
                this.buyInfo.page += 1;
                this.buyInfo.data = undefined
                this.getBuys()
            }
        }
        if (type === SuggestionType.SELL) {
            if (this.sellInfo.page < this.sellInfo.totalPages) {
                this.sellInfo.page += 1;
                this.sellInfo.data = undefined
                this.getSells()
            }
        }
        if (type === SuggestionType.HOLD) {
            if (this.holdInfo.page < this.holdInfo.totalPages) {
                this.holdInfo.page += 1;
                this.holdInfo.data = undefined
                this.getHolds()
            }
        }
        if (type === SuggestionType.COMBINATION) {
            if (this.combinationInfo.page < this.combinationInfo.totalPages) {
                this.combinationInfo.page += 1;
                this.combinationInfo.data = undefined
                this.getCombinations()
            }
        }
    }
    updateStockSymbol(data: IStockSymbol[]) {
        if (this.holdInfo.data) {
            this.holdInfo.data.map((currentStock, index) => {
                let newStock = data.find((index) => (index.stockSymbol === currentStock.ticker))
                if (newStock && this.holdInfo.data) {
                    let t: IStockSymbol = _.cloneDeep(newStock);
                    if (currentStock.matchPrice && t.matchPrice && currentStock.matchPrice < t.matchPrice) {
                        currentStock.colorUpdate = STOCK_BG_COLOR_CONIG.UP
                    }
                    if (currentStock.matchPrice && t.matchPrice && currentStock.matchPrice > t.matchPrice) {
                        currentStock.colorUpdate = STOCK_BG_COLOR_CONIG.DOWN
                    }
                    currentStock.basicPrice = t.basicPrice;
                    currentStock.ceilingPrice = t.ceilingPrice;
                    currentStock.floorPrice = t.floorPrice;
                    currentStock.matchPrice = t.matchPrice
                    setTimeout(() => {
                        if (this.holdInfo.data) {
                            this.holdInfo.data[index].colorUpdate = ""
                        }

                    }, Constants.EFFECT_UPDATE_TIME)
                }
            })
        }
        if (this.buyInfo.data) {
            this.buyInfo.data.map((currentStock, index) => {
                let newStock = data.find((index) => (index.stockSymbol === currentStock.ticker))
                if (newStock && this.buyInfo.data) {
                    let t: IStockSymbol = _.cloneDeep(newStock);
                    if (currentStock.matchPrice && t.matchPrice && currentStock.matchPrice < t.matchPrice) {
                        currentStock.colorUpdate = STOCK_BG_COLOR_CONIG.UP
                    }
                    if (currentStock.matchPrice && t.matchPrice && currentStock.matchPrice > t.matchPrice) {
                        currentStock.colorUpdate = STOCK_BG_COLOR_CONIG.DOWN
                    }
                    currentStock.basicPrice = t.basicPrice;
                    currentStock.ceilingPrice = t.ceilingPrice;
                    currentStock.floorPrice = t.floorPrice;
                    currentStock.matchPrice = t.matchPrice
                    setTimeout(() => {
                        if (this.buyInfo.data) {
                            this.buyInfo.data[index].colorUpdate = ""
                        }

                    }, Constants.EFFECT_UPDATE_TIME)
                }
            })
        }
    }
}
export const stockRecommendationStore = new StockRecommendationStore()